import { computePosition, flip, shift, offset, autoUpdate } from "@floating-ui/dom"

// Gap between the composer and the menu, and how close the menu may get to the
// viewport edge before it flips or slides.
const ANCHOR_OFFSET = 6
const VIEWPORT_PADDING = 8

// Pins one of the composer's popup menus (`/` skills, `@` mentions) to the
// editor. Anchored to the editor rather than the caret so the menu doesn't jump
// around while the user types, and flipped/shifted so it opens into whichever
// space is available — the panel can be docked at any height.
//
// Returns floating-ui's cleanup function; callers must invoke it when the menu
// closes or the controller disconnects, or the scroll/resize listeners outlive
// the menu.
export function anchorMenu(editor, menu) {
  return autoUpdate(editor, menu, async () => {
    const { x, y } = await computePosition(editor, menu, {
      placement: "top-start",
      strategy: "fixed",
      middleware: [offset(ANCHOR_OFFSET), flip({ padding: VIEWPORT_PADDING }), shift({ padding: VIEWPORT_PADDING })],
    })
    Object.assign(menu.style, { position: "fixed", left: `${x}px`, top: `${y}px` })
  })
}
